import { render, staticRenderFns } from "./AllTeam.vue?vue&type=template&id=9bdb8f0a&scoped=true&"
import script from "./AllTeam.vue?vue&type=script&lang=js&"
export * from "./AllTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdb8f0a",
  null
  
)

export default component.exports